import { homeConstants } from '../_constants/home.constants';
import {
  setIsFetching,
  filterDataResults,
  resetDataResults,
  filterIsOpenModal,
  updateFundIds
} from '../_utils/home.utils';

const initialState = {
  banner: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  highlightFund: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  navFund: {
    fundIds: [],
    navDate: '1Y',
    isFetching: false,
    data: [],
    errorMessage: null
  },
  topSubCategory: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  article: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  openSectionModal: {
    isOpenModal: false,
    data: null
  }
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case homeConstants.FETCH_BANNERS_START:
      return {
        ...state,
        banner: setIsFetching(state.banner)
      };
    case homeConstants.FETCH_BANNERS_SUCCESS:
      return {
        ...state,
        banner: filterDataResults(state.banner, action.payload)
      };
    case homeConstants.FETCH_BANNERS_FAILURE:
      return {
        ...state,
        banner: resetDataResults(state.banner, action.payload)
      };
    case homeConstants.FETCH_HIGHLIGHT_FUNDS_START:
      return {
        ...state,
        highlightFund: setIsFetching(state.highlightFund)
      };
    case homeConstants.FETCH_HIGHLIGHT_FUNDS_SUCCESS:
      return {
        ...state,
        highlightFund: filterDataResults(state.highlightFund, action.payload)
      };
    case homeConstants.FETCH_HIGHLIGHT_FUNDS_FAILURE:
      return {
        ...state,
        highlightFund: resetDataResults(state.highlightFund, action.payload)
      };
    case homeConstants.UPDATE_NAV_FUNDS:
      return {
        ...state,
        navFund: updateFundIds(state.navFund, action.payload)
      };
    case homeConstants.FETCH_NAV_FUNDS_START:
      return {
        ...state,
        navFund: setIsFetching(state.navFund)
      };
    case homeConstants.FETCH_NAV_FUNDS_SUCCESS:
      return {
        ...state,
        navFund: filterDataResults(state.navFund, action.payload)
      };
    case homeConstants.FETCH_NAV_FUNDS_FAILURE:
      return {
        ...state,
        navFund: resetDataResults(state.navFund, action.payload)
      };
    case homeConstants.FETCH_TOP_SUB_CATEGORIES_START:
      return {
        ...state,
        topSubCategory: setIsFetching(state.topSubCategory)
      };
    case homeConstants.FETCH_TOP_SUB_CATEGORIES_SUCCESS:
      return {
        ...state,
        topSubCategory: filterDataResults(state.topSubCategory, action.payload)
      };
    case homeConstants.FETCH_TOP_SUB_CATEGORIES_FAILURE:
      return {
        ...state,
        topSubCategory: resetDataResults(state.topSubCategory, action.payload)
      };
    case homeConstants.FETCH_ARTICLES_START:
      return {
        ...state,
        article: setIsFetching(state.article)
      };
    case homeConstants.FETCH_ARTICLES_SUCCESS:
      return {
        ...state,
        article: filterDataResults(state.article, action.payload)
      };
    case homeConstants.FETCH_ARTICLES_FAILURE:
      return {
        ...state,
        article: resetDataResults(state.article, action.payload)
      };
    case homeConstants.TOGGLE_ARTICLE_MODAL:
      return {
        ...state,
        openSectionModal: filterIsOpenModal(state.openSectionModal, action.payload)
      };
    default:
      return state;
  }
};

export default homeReducer;
